import { createSelector, createFeatureSelector } from '@ngrx/store';
import { CompaniesState } from './companies.reducer';

export const selectCompaniesState =
  createFeatureSelector<CompaniesState>('companies');

// List selectors
export const selectCompanies = createSelector(
  selectCompaniesState,
  state => state.companies
);

export const selectCompanyItems = createSelector(
  selectCompanies,
  companies => companies?.items ?? []
);

export const selectCompaniesLoading = createSelector(
  selectCompaniesState,
  state => state.loading
);

export const selectCompaniesError = createSelector(
  selectCompaniesState,
  state => state.error
);

export const selectCurrentPage = createSelector(
  selectCompaniesState,
  state => state.currentPage
);

export const selectPageSize = createSelector(
  selectCompaniesState,
  state => state.pageSize
);

export const selectSearchTerm = createSelector(
  selectCompaniesState,
  state => state.searchTerm
);

export const selectSortBy = createSelector(
  selectCompaniesState,
  state => state.sortBy
);

export const selectSortOrder = createSelector(
  selectCompaniesState,
  state => state.sortOrder
);

export const selectTotalCount = createSelector(
  selectCompanies,
  companies => companies?.totalCount ?? 0
);

export const selectTotalPages = createSelector(
  selectCompanies,
  companies => companies?.totalPages ?? 0
);

// Detail selectors
export const selectCurrentCompany = createSelector(
  selectCompaniesState,
  state => state.currentCompany
);

export const selectCurrentCompanyLoading = createSelector(
  selectCompaniesState,
  state => state.currentCompanyLoading
);

export const selectCurrentCompanyError = createSelector(
  selectCompaniesState,
  state => state.currentCompanyError
);

// Form selectors
export const selectSaving = createSelector(
  selectCompaniesState,
  state => state.saving
);

export const selectSaveError = createSelector(
  selectCompaniesState,
  state => state.saveError
);

export const selectSaveSuccess = createSelector(
  selectCompaniesState,
  state => state.saveSuccess
);

export const selectARNumberExists = createSelector(
  selectCompaniesState,
  state => state.arNumberExists
);

export const selectSalesforceResults = createSelector(
  selectCompaniesState,
  state => state.salesforceResults
);

export const selectSalesforceLoading = createSelector(
  selectCompaniesState,
  state => state.salesforceLoading
);
